<!-- <div class="navbar bg-base-100 shadow-sm"> -->
<div class="navbar shadow-sm" classOnScroll="nav-white">
  <!-- logo -->
  <div class="flex-1 hidden-phone">
  	<img src="img/logo/white-full.png" class="logo-white ml-4" alt="Logo"/>
  	<img src="img/logo/violet-full.png" class="logo-violet ml-4" alt="Logo"/>
  </div>

  <div class="flex-1 display-phone">
  	<img src="img/logo/logo-white.png" class="logo-white ml-4" alt="Logo"/>
  	<img src="img/logo/logo-violet.png" class="logo-violet ml-4" alt="Logo"/>
  </div>

  <!-- button -->
  <div class="flex-none">
  	<span class="hidden-phone change-color text-base-100">Disponible sur iOS et Android</span>
    <a [attr.href]="url" title="downloads" class="btn btn-primary btn-gradient mr-2 ml-4">Installer</a>
  </div>

  <!-- Menu -->
  <div class="flex-none">
    <div class="drawer drawer-end">
		  <input id="my-drawer-5" type="checkbox" class="drawer-toggle" />
		  <div class="drawer-content">
		    <!-- Page content here -->
		    <label for="my-drawer-5" class="drawer-button btn btn-ghost">
		    	<i class="change-color text-base-100 fa-light fa-bars-staggered"></i>
		    </label>
		  </div>
		  <div class="drawer-side">
		    <label for="my-drawer-5" aria-label="close sidebar" class="drawer-overlay"></label>
		    <ul class="menu bg-base-200 min-h-full w-80 p-4">
		      <!-- Sidebar content here -->
		      <li><a [routerLink]="router.get('home')" title="Application Legende-Binder">Legend-binder</a></li>
		      <li><a [attr.href]="url" title="Installer Legend-Binder">Installer</a></li>
		      <!-- <li><a>Contact</a></li> -->
		      <li class="rs-container">
						<div class="social-icon mr-2">
							<a href="https://www.facebook.com/people/Legend-Binder/61588921773391/" title="facebook">
								<i class="text-base-100 text-xl fa-brands fa-facebook-f"></i>
							</a>
						</div>

						<div class="social-icon orange mr-2">
							<a href="https://www.instagram.com/legend_binder/" title="instagram">
								<i class="text-base-100 text-xl fa-brands fa-instagram"></i>
							</a>
						</div>

						<div class="social-icon black mr-2">
							<a href="https://www.tiktok.com/@legend_binder" title="tiktok">
								<i class="text-base-100 text-xl fa-brands fa-tiktok"></i>
							</a>
						</div>

						<div>
							<a [href]="urlCGV" title="Conditions générales de vente">CGV</a>
						</div>
		      </li>
		    </ul>
		  </div>
	</div>
  </div>
</div>